
import { InjectableService } from "@/shared/services/InjectableService";
import { WizardModel } from "../models/WizardModel";
import { WizardStep, WizardStepStatusType } from "../models/WizardStep";
import { WizardStepAvailabiltyModel } from "../models/WizardStepAvailabilityModel";


export abstract class WizardNavigationService<TSharedModel, TStep extends WizardStep<TSharedModel>, TStepType extends string | number> extends InjectableService {

    public abstract getIsStepAvailable(stepType: TStepType, sharedModel: TSharedModel): WizardStepAvailabiltyModel;

    public abstract getPreviousWizardStep(activeStep: TStep, steps: Array<TStep>): TStep | undefined;

    public abstract getNextWizardStep(activeStep: TStep, steps: Array<TStep>): TStep | undefined;

    public abstract setActiveWizardStep(step: TStep, wizardModel: WizardModel<TStep, TSharedModel>): void;

    public abstract setActiveWizardStepByType(stepType: TStepType, wizardModel: WizardModel<TStep, TSharedModel>): void;

    public abstract trySetWizardActiveStepStatus(wizardModel: WizardModel<TStep, TSharedModel>, statusType: WizardStepStatusType, message?: string): void
}